import React from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
import AddOrEditCustomFieldsReduxForm from '../layout/reduxForm/AddOrEditCustomFieldsReduxForm';
import handleSubmit from '../../utils/reduxForm/onSubmit/addOrEditCustomFields';

const AddOrEditCustomFields = ({ modalState, toggleModal }) => {
  const typeData = modalState.type && typeof modalState.type === 'object'
    ? modalState.type
    : {};
  const { name, _id } = typeData;

  const closeModal = () => {
    toggleModal(false, 'addOrEditCustomFields');
  };

  if (!modalState.isOpen) {
    return null;
  }

  return (
    <div className="popup_block dashboard-modal showed">
      <div className="popup_container">
        <div className="popup_head">
          <div className="popup_title">
            {_id ? 'Edit custom field name' : 'Create custom field'}
          </div>
          <button type="button" className="close_btn" aria-label="close" onClick={closeModal}>
            ×
          </button>
        </div>
        <AddOrEditCustomFieldsReduxForm
          initialValues={{ name: name || '', _id }}
          onSubmit={handleSubmit}
          closeModal={closeModal}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  modalState: state.modalState.addOrEditCustomFields,
});

export default connect(mapStateToProps, { toggleModal })(AddOrEditCustomFields);
